import script from "./object_simplePage.vue?vue&type=script&setup=true&lang=js"
export * from "./object_simplePage.vue?vue&type=script&setup=true&lang=js"

import "./object_simplePage.vue?vue&type=style&index=0&id=7211335e&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7211335e"]])

export default __exports__